module.exports = __webpack_public_path__ + "assets/be1f84b71e866ae9fac836dc5e28cfe4.mp3";